// extracted by mini-css-extract-plugin
module.exports = {"TaskCreator":"TaskCreator_TaskCreator__1QbBb","CreatorBox":"TaskCreator_CreatorBox__2P-7k","CharCounter":"TaskCreator_CharCounter__Eo-aQ"};